/**
 * V70.27: `조직관리 > 인력 현황` 페이지 접근 가드
 *
 * 허용
 *  - Admin (서버 `checkIsAdminLike` = ADMIN_LIKE_ROLES) → 별도 등록 없이 통과
 *  - `Admin > 인력 현황 관리` 에서 접근 사용자로 등록된 사용자
 *
 * 불허: 위 어디에도 해당하지 않는 모든 사용자 (직접 URL 입력 포함)
 *
 * 설계 근거
 *  - `WorkforceAccessGuard` (V68) 패턴을 그대로 따른다. 다만 역할 고정 목록이 아니라
 *    서버 설정(allowedUserIds)을 조회하는 `useWorkforceOverviewAccess` 를 사용한다.
 *  - 메뉴 숨김(Sidebar)과 별개로 **라우트 단계에서 한 번 더 차단**한다.
 *  - 권한 판정 SSoT 는 서버 callable 이며, 이 가드는 그 결과를 렌더에 반영할 뿐이다.
 */
import React from 'react';
import { useWorkforceOverviewAccess } from '../shared/hooks/useWorkforceOverviewAccess';

interface Props {
  children: React.ReactElement;
}

export function WorkforceOverviewAccessGuard({ children }: Props) {
  const { canAccess, isLoading } = useWorkforceOverviewAccess();

  if (isLoading) {
    return (
      <div style={{
        display: 'flex', justifyContent: 'center', alignItems: 'center',
        minHeight: '200px', color: 'var(--color-gray-500)',
      }}>
        권한 확인 중...
      </div>
    );
  }

  if (!canAccess) {
    return (
      <div style={{ padding: '40px', textAlign: 'center' }}>
        <div style={{ fontSize: '48px', marginBottom: '16px' }}>🔒</div>
        <h2 style={{ fontSize: '24px', fontWeight: 'bold', color: 'var(--color-gray-800)', marginBottom: '12px' }}>
          접근 권한이 없습니다
        </h2>
        <p style={{ color: 'var(--color-gray-600)', marginBottom: '8px' }}>
          인력 현황 페이지는 관리자 또는 별도로 등록된 사용자만 접근할 수 있습니다.
        </p>
        <p style={{ color: 'var(--color-gray-500)', fontSize: '13px' }}>
          접근이 필요하면 관리자에게 요청해 주세요.
        </p>
        <div style={{ marginTop: '24px' }}>
          <button
            onClick={() => window.history.back()}
            style={{
              padding: '8px 24px', background: 'var(--color-primary)', color: 'white',
              border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '14px',
            }}
          >
            뒤로 가기
          </button>
        </div>
      </div>
    );
  }

  return children;
}
